import * as mock from "./mock";
import { create } from "../UtilsOld";

const Service = {};
const option = [
    /**
     * 新增
     * @param { JSON } 专家对象
     */
    ["apply", "/v1/user/zhuanjia/apply", "post", true],
    /**
     * 新增
     * @param { JSON } 专家对象
     */
    ["add", "/v1/user/zhuanjia", "post", true],
    /**
     * 修改
     * @param { Array } ids 专家标识列表
     */
    ["update", "/v1/user/zhuanjia", "put", true],
    /**
     * 删除
     * @param { Array } ids 专家标识列表
     */
    ["delete", "/v1/user/zhuanjia", "delete", true],
    /**
     * 审核
     * @param { Array } ids 专家标识列表
     * @param { Number } status 审核状态（2 驳回 3 审核）
     * @param { String } reason 审核原由
     */
    ["audit", "/v1/user/zhuanjia/audit", "post", true],
    /**
     * 专家详情
     * @param { Number } zhuanjiaId 专家 ID
     */
    ["detail", "/v1/zhuanjia/detail", "get", true],
    /**
     * 查询我的申请信息
     */
    ["applyProgress", "/v1/user/zhuanjia/list", "get", true],
    /**
     * 专家列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["auditList", "/v1/zhuanjia/audit/list", "get", true],
    /**
     * 项目列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["list", "/v1/zhuanjia/list", "get", true],
    /**
     * 项目推荐列表
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     */
    ["recommendList", "/zaicu/recommend/list", "get", true],
    /**
     * 周期统计
     * API http://116.255.247.58:3000/project/17/interface/api/31
     * @param { String } areaCode 区域编码
     * @param { Number } level 区域级别 1:省,2:地市,3:区县
     */
    ["dateNumStatistics", "/v1/zhuanjia/default/statistics", "get", true],
]

create(option, Service, mock)

export default {
    Service,
    option
};
